import { render, staticRenderFns } from "./MembershipDetail.vue?vue&type=template&id=567b35b4&scoped=true"
import script from "./MembershipDetail.vue?vue&type=script&lang=js"
export * from "./MembershipDetail.vue?vue&type=script&lang=js"
import style0 from "./MembershipDetail.vue?vue&type=style&index=0&id=567b35b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b35b4",
  null
  
)

export default component.exports